import { getYoutubeEmbedLink, isYouTubeVideo } from '.';
import { BrochureProps } from './videoModal.props';
import { Div, VideoURLLink } from './videoModal.styled';

const ServiceVideoModal = ({ dataService, isService }: BrochureProps) => {
    var videoIdService = null;

    if (dataService?.commerceFirmData?.videoLink) {
        videoIdService = getYoutubeEmbedLink(dataService?.commerceFirmData?.videoLink);
    }

    return (
        <>
            {videoIdService && isYouTubeVideo(dataService!.commerceFirmData!.videoLink!) ?
                (< Div className="description w-full" >
                    <Div className="outerCon w-full" >
                        <iframe className='video'
                            title='Youtube player'
                            src={videoIdService}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen={true}
                            >
                        </iframe>
                    </Div>
                </Div >) :
                (< VideoURLLink
                    className="video-url-service"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={dataService!.commerceFirmData?.videoLink}>
                    {dataService!.commerceFirmData!.videoLink!.length > 50 ? `${dataService!.commerceFirmData?.videoLink?.slice(0, 50)}...` : dataService!.commerceFirmData?.videoLink}
                </VideoURLLink >)
            }
        </>
    )
};

export default ServiceVideoModal;